<p-accordionTab #finalUsersDiv>
	<ng-template pTemplate="header">
		<div class="grid flex align-items-center w-full -mb-3">
			<div [class]="!onExtendedMobile() ? 'col-10' : 'col-12 flex justify-content-center'" class="py-0">
				<span class="font-semibold white-space-nowrap">{{ 'ENABLED_USERS' | translate }}</span>
			</div>
			<div [class]="!onExtendedMobile() ? 'col-2 flex justify-content-end' : 'col-12 flex justify-content-center'"
				class="py-0 pr-0">
				<p-button *ngIf="hasImportFinalUsers()" pTooltip="{{ 'EXPORT_LIST_FINAL_USERS' | translate }}" class=""
					[disabled]="exporting || deleting || isEmptyFinalUsers()" tooltipPosition="bottom"
					icon="pi cm-cloud-arrow-up" size="large" (click)="$event.stopPropagation(); exportListFinalUser()"
					[rounded]="false" [text]="true" severity="secondary">
				</p-button>
				<p-button pTooltip="{{ 'DELETE_ALL' | translate }}" class=""
					[disabled]="exporting || deleting || isEmptyFinalUsers()" tooltipPosition="bottom" icon="pi cm-trash"
					size="large" (click)="$event.stopPropagation(); deleteFinalUsers()" [rounded]="false" [text]="true"
					severity="danger">
				</p-button>
			</div>
		</div>
	</ng-template>
	<div class="flex align-items-center justify-content-center w-full pb-8 mb-8" *ngIf="deleting || importing">
		<p-progressSpinner ariaLabel="loading"></p-progressSpinner>
	</div>
	<div class="grid" *ngIf="!deleting || !importing">
		<div class="col-12 flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl"
			*ngIf="finalUsers.length <= 0">
			<p-tag icon="pi cm-alert" [value]="('NO_FINAL_USERS' | translate)" severity="warning"
				styleClass="text-lg"></p-tag>
		</div>
		<div class="col-12 p-0" *ngIf="finalUsers.length > 0">
			<div class="card">
				<p-table #tableFinalUsers dataKey="Email" [value]="finalUsers" [paginator]="true" [rows]="pageSize"
					[totalRecords]="totalRecords" [showCurrentPageReport]="true"
					currentPageReportTemplate="{{ 'TABLE_REPORT' | translate }}" [autoLayout]="true"
					responsiveLayout="stack">
					<ng-template pTemplate="header" class="flex align-items-center justify-content-center">
						<tr>
							<th style="width: 5rem"></th>
							<th>
								<div pSortableColumn="FirstName" class="flex align-items-center justify-content-center">
									{{ 'FIRST_NAME' | translate }}
									<p-sortIcon field="FirstName"></p-sortIcon>
								</div>
							</th>
							<th>
								<div pSortableColumn="LastName" class="flex align-items-center justify-content-center">
									{{ 'LAST_NAME' | translate }}
									<p-sortIcon field="LastName"></p-sortIcon>
								</div>
							</th>
							<th>
								<div pSortableColumn="Email" class="flex align-items-center justify-content-center">
									{{ 'EMAIL' | translate }}
									<p-sortIcon field="Email"></p-sortIcon>
								</div>
							</th>
							<th>
								<div pSortableColumn="Username" class="flex align-items-center justify-content-center">
									{{ 'USERNAME' | translate }}
									<p-sortIcon field="Username"></p-sortIcon>
								</div>
							</th>
							<th>
								<div pSortableColumn="Id" class="flex align-items-center justify-content-center">
									{{ 'INVITATION' | translate }}
									<p-sortIcon field="Id"></p-sortIcon>
								</div>
							</th>
							<th>
								<div class="flex align-items-center justify-content-center">{{ 'AVAILABLE_REMOTE_DEVICES' |
									translate }}</div>
							</th>
							<th>
								<div class="flex align-items-center justify-content-center">{{ 'LOCKED_USER' |
									translate }}</div>
							</th>
							<th>
								<div class="flex align-items-center justify-content-center"></div>
							</th>
						</tr>
					</ng-template>
					<ng-template pTemplate="body" let-user let-expanded="expanded">
						<tr>
							<td>
								<button type="button" pButton pRipple [pRowToggler]="user"
									class="p-button-rounded p-button-plain"
									[icon]="expanded ? 'pi cm-angle-down' : 'pi cm-angle-right'"></button>
							</td>
							<td>
								<span class="p-column-title font-semibold">{{ 'FIRST_NAME' | translate }}</span>
								<div class="flex align-items-center justify-content-center">{{ user.FirstName }}</div>
							</td>
							<td>
								<span class="p-column-title font-semibold">{{ 'LAST_NAME' | translate }}</span>
								<div class="flex align-items-center justify-content-center">{{ user.LastName }}</div>
							</td>
							<td>
								<span class="p-column-title font-semibold">{{ 'EMAIL' | translate }}</span>
								<div class="flex align-items-center justify-content-center">{{ user.Email }}</div>
							</td>
							<td>
								<span class="p-column-title font-semibold">{{ 'USERNAME' | translate }}</span>
								<p-tag *ngIf="user !== undefined && user.Username !== undefined && user.Username !== ''"
									styleClass="p-tag-purple">{{ user.Username }}</p-tag>
							</td>
							<td>
								<span class="p-column-title font-semibold">{{ 'INVITATION' | translate }}</span>
								<div class="flex align-items-center justify-content-center">
									<p-tag
										[value]="!user.Id? ('INVITATION_PENDING_NEW' | translate) : ('INVITATION_ACCEPTED_NEW' | translate)"
										[severity]="!user.Id? 'warning' : 'success'">
									</p-tag>
								</div>
							</td>
							<td>
								<span class="p-column-title font-semibold">{{ 'AVAILABLE_REMOTE_DEVICES' | translate }}</span>
								<div class="flex align-items-center justify-content-center">{{ claimedSlotsStr(user.Id) }}</div>
							</td>
							<td>
								<span class="p-column-title font-semibold">{{ 'LOCKED_USER' | translate }}</span>
								<div class="flex align-items-center justify-content-center">{{ claimedSlotLockedUser(user.Id) }}
								</div>
							</td>
							<td>
								<span class="p-column-title"></span>
								<div class="flex flex-row justify-content-center align-items-center gap-1">
									<p-button pTooltip="{{ 'DELETE_USER' | translate}}" tooltipPosition="bottom"
										icon="pi cm-trash" size="large" (click)="deleteUser(user)" [rounded]="false" [text]="true"
										severity="danger">
									</p-button>
								</div>
							</td>
						</tr>
					</ng-template>
					<ng-template pTemplate="rowexpansion" let-user>
						<tr>
							<td colspan="12" class="p-0 px-3">
								<div class="grid">
									<div class="col-12 pb-0">
										<div *ngIf="claimedSlotsStr(user.Id) === '-'"
											class="flex flex-row w-full align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl">
											<p-tag icon="pi cm-alert"
												value="{{('INVITATION_TO_BE_CONFIRM' | translate ) + '. ' + ('TABLE_REMOTE_CLIENTS_NO_ELEMENT' | translate ) }}"
												severity="warning" styleClass="text-lg"></p-tag>
										</div>
										<div *ngIf="claimedSlotsStr(user.Id) !== '-'"
											class="flex flex-row w-full align-items-center justify-content-center bg-blue-200 p-1 border-round-top-xl">
											<div class="grid m-0 w-full flex align-items-center justify-content-center">
												<div [class]="col6Resp()">
													{{ 'LICENCES_APP_AUTOMATION' | translate }} {{ user.Email }}
												</div>
												<div [class]="col6Resp()">
													<div class="flex justify-content-between flex-wrap border-bottom-1 border-400"
														[ngClass]="simpleInputTextLayout('borderRow')">
														<div class="flex align-items-center justify-content-center"
															[ngClass]="simpleInputTextLayout('label')">{{ 'MAX_REMOTES' | translate }}
														</div>
														<div class="flex align-items-center justify-content-center"
															[ngClass]="simpleInputTextLayout('borderInput')">
															<p-dropdown [options]="claimedSlots(user.Id).SlotsRange"
																[(ngModel)]="claimedSlots(user.Id).MaxSlots"
																[ngClass]="dynamicInputTextWidth()"
																(onChange)="changeMaxSlots($event, user.Id)" appendTo="body"
																styleClass="{{ dynamicInputTextWidth() }} align-items-center pl-5"
																id="change-max-remotes" placeholder="{{ 'MAX_REMOTES' | translate }}">
																<ng-template let-item pTemplate="selectedItem">
																	<div class="item"
																		class="flex align-items-center justify-content-center">
																		<div class="flex justify-content-center">{{ item }}</div>
																	</div>
																</ng-template>
																<ng-template let-item pTemplate="item">
																	<div class="item flex align-items-center justify-content-center">
																		<div>{{ item }}</div>
																	</div>
																</ng-template>
															</p-dropdown>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="col-12 pt-0">
										<div *ngIf="remoteClientLockingUnlocking || remoteClientDeleting"
											class="flex align-items-center justify-content-center w-full">
											<p-progressSpinner ariaLabel="loading"></p-progressSpinner>
										</div>
										<p-table
											*ngIf="claimedSlotsStr(user.Id) !== '-' && !remoteClientLockingUnlocking && !remoteClientDeleting"
											#tableClaimedSlots styleClass="surface-400" dataKey="i"
											[value]="claimedSlots(user.Id).ClaimedSlots"
											currentPageReportTemplate="{{ 'TABLE_REPORT' | translate }}" [autoLayout]="true"
											responsiveLayout="stack">
											<ng-template pTemplate="header" class="flex align-items-center justify-content-center"
												*ngIf="claimedSlots(user.Id).ClaimedSlots.length > 0">
						<tr>
							<th>
								<div class="flex align-items-center justify-content-center">{{ 'DESCRIPTION' | translate }}
								</div>
							</th>
							<th>
								<div class="flex align-items-center justify-content-center">{{ 'LICENSE_ID' | translate }}</div>
							</th>
							<th>
								<div class="flex align-items-center justify-content-center">{{ 'CLIENT_ID' | translate }}</div>
							</th>
							<th>
								<div class="flex align-items-center justify-content-center">{{ 'ENABLED' | translate }}</div>
							</th>
							<th>
								<div class="flex align-items-center justify-content-center"></div>
							</th>
						</tr>
					</ng-template>
					<ng-template pTemplate="body" let-slot>
						<tr>
							<td>
								<span class="p-column-title font-semibold">{{ 'DESCRIPTION' | translate }}</span>
								<div class="flex align-items-center justify-content-center">{{ slot.ClientInfo }}</div>
							</td>
							<td>
								<span class="p-column-title font-semibold">{{ 'LICENSE_ID' | translate }}</span>
								<div class="flex align-items-center justify-content-center">{{ slot.Id }}</div>
							</td>
							<td>
								<span class="p-column-title font-semibold">{{ 'CLIENT_ID' | translate }}</span>
								<div class="flex align-items-center justify-content-center">{{ slot.ClientId }}</div>
							</td>
							<td>
								<span class="p-column-title font-semibold">{{ 'ENABLED' | translate }}</span>
								<div class="flex align-items-center justify-content-center">{{slot.Enabled ? ('YES' | translate)
									: ('NO' | translate)}}</div>
							</td>
							<td>
								<span class="p-column-title"></span>
								<div class="flex flex-row justify-content-center align-items-center gap-1">
									<p-button pTooltip="{{ (slot.Locked ? 'UNLOCK_CLIENT' : 'LOCK_CLIENT') | translate }}"
										tooltipPosition="bottom" icon="{{ slot.Locked ? 'pi cm-lock' : 'pi cm-unlock' }}"
										size="large" (click)="toggleClientLock(slot)" [rounded]="false" [text]="true"
										severity="{{slot.Locked ? 'danger':'primary'}}">
									</p-button>
									<p-button pTooltip="{{ 'DELETE_CLIENT' | translate}}" tooltipPosition="bottom"
										icon="pi cm-trash" size="large" (click)="deleteClient(slot)" [rounded]="false"
										[text]="true" severity="danger">
									</p-button>
								</div>
							</td>
						</tr>
					</ng-template>
					<ng-template pTemplate="emptymessage">
						<tr>
							<td colspan="12">{{ 'TABLE_REMOTE_CLIENTS_NO_ELEMENT' | translate }}</td>
						</tr>
					</ng-template>
				</p-table>
			</div>
		</div>
		</td>
		</tr>
		</ng-template>
		<ng-template pTemplate="emptymessage">
			<tr>
				<td colspan="12">{{ 'TABLE_NO_ELEMENT' | translate }}</td>
			</tr>
		</ng-template>
		</p-table>
	</div>
	</div>
	</div>

	<p-confirmDialog #confDialog>
		<ng-template pTemplate="footer">
			<div class="col-12 flex justify-content-center">
				<button type="button" pButton [label]="confDialog.acceptButtonLabel" [ngClass]="acceptButtonStyle"
					(click)="confDialog.accept()">
				</button>
				<button type="button" pButton [label]="confDialog.rejectButtonLabel" [ngClass]="rejectButtonStyle"
					(click)="confDialog.reject()">
				</button>
			</div>
		</ng-template>
	</p-confirmDialog>
</p-accordionTab>